/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  FundingOpportunity,
  FundingOpportunityCreationArgs,
  FundingOpportunityDeleteArgs,
  FundingOpportunityUpdateArgs,
  GetFundingOpportunitiesAdminParams,
  GetFundingOpportunitiesParams,
  HTTPValidationError,
} from './platformapi.schemas';

import getFundingOpportunitiesAdminMutator from '../custom-axios-instance';
import countFundingOpportunitiesAdminMutator from '../custom-axios-instance';
import createFundingOpportunityMutator from '../custom-axios-instance';
import deleteFundingOpportunityMutator from '../custom-axios-instance';
import updateFundingOpportunityMutator from '../custom-axios-instance';
import getFundingOpportunitiesMutator from '../custom-axios-instance';
import countFundingOpportunitiesMutator from '../custom-axios-instance';

/**
 * Gets all funding opportunities regardless of date
 * @summary Get Funding Opportunities Admin
 */
export const getFundingOpportunitiesAdmin = (
  params: GetFundingOpportunitiesAdminParams,
  signal?: AbortSignal,
) => {
  return getFundingOpportunitiesAdminMutator<FundingOpportunity[]>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetFundingOpportunitiesAdminQueryKey = (
  params?: GetFundingOpportunitiesAdminParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFundingOpportunitiesAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFundingOpportunitiesAdminQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>> = ({
    signal,
  }) => getFundingOpportunitiesAdmin(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFundingOpportunitiesAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>
>;
export type GetFundingOpportunitiesAdminQueryError = void | HTTPValidationError;

export function useGetFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesAdminParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
          TError,
          Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
          TError,
          Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Funding Opportunities Admin
 */

export function useGetFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesAdminParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunitiesAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFundingOpportunitiesAdminQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Counts all funding opportunities regardless of date
 * @summary Count Funding Opportunities Admin
 */
export const countFundingOpportunitiesAdmin = (signal?: AbortSignal) => {
  return countFundingOpportunitiesAdminMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/count`,
    method: 'GET',
    signal,
  });
};

export const getCountFundingOpportunitiesAdminQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/count`] as const;
};

export const getCountFundingOpportunitiesAdminQueryOptions = <
  TData = Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountFundingOpportunitiesAdminQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>> = ({
    signal,
  }) => countFundingOpportunitiesAdmin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountFundingOpportunitiesAdminQueryResult = NonNullable<
  Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>
>;
export type CountFundingOpportunitiesAdminQueryError = void | HTTPValidationError;

export function useCountFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
          TError,
          Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
          TError,
          Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Funding Opportunities Admin
 */

export function useCountFundingOpportunitiesAdmin<
  TData = Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunitiesAdmin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountFundingOpportunitiesAdminQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new funding opportunity
 * @summary Create Funding Opportunity
 */
export const createFundingOpportunity = (
  fundingOpportunityCreationArgs: FundingOpportunityCreationArgs,
  signal?: AbortSignal,
) => {
  return createFundingOpportunityMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fundingOpportunityCreationArgs,
    signal,
  });
};

export const getCreateFundingOpportunityMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFundingOpportunity>>,
    TError,
    { data: FundingOpportunityCreationArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFundingOpportunity>>,
  TError,
  { data: FundingOpportunityCreationArgs },
  TContext
> => {
  const mutationKey = ['createFundingOpportunity'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFundingOpportunity>>,
    { data: FundingOpportunityCreationArgs }
  > = (props) => {
    const { data } = props ?? {};

    return createFundingOpportunity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFundingOpportunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFundingOpportunity>>
>;
export type CreateFundingOpportunityMutationBody = FundingOpportunityCreationArgs;
export type CreateFundingOpportunityMutationError = void | HTTPValidationError;

/**
 * @summary Create Funding Opportunity
 */
export const useCreateFundingOpportunity = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFundingOpportunity>>,
      TError,
      { data: FundingOpportunityCreationArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFundingOpportunity>>,
  TError,
  { data: FundingOpportunityCreationArgs },
  TContext
> => {
  const mutationOptions = getCreateFundingOpportunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a funding opportunity
 * @summary Delete Funding Opportunity
 */
export const deleteFundingOpportunity = (
  fundingOpportunityDeleteArgs: FundingOpportunityDeleteArgs,
  signal?: AbortSignal,
) => {
  return deleteFundingOpportunityMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fundingOpportunityDeleteArgs,
    signal,
  });
};

export const getDeleteFundingOpportunityMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFundingOpportunity>>,
    TError,
    { data: FundingOpportunityDeleteArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFundingOpportunity>>,
  TError,
  { data: FundingOpportunityDeleteArgs },
  TContext
> => {
  const mutationKey = ['deleteFundingOpportunity'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFundingOpportunity>>,
    { data: FundingOpportunityDeleteArgs }
  > = (props) => {
    const { data } = props ?? {};

    return deleteFundingOpportunity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFundingOpportunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFundingOpportunity>>
>;
export type DeleteFundingOpportunityMutationBody = FundingOpportunityDeleteArgs;
export type DeleteFundingOpportunityMutationError = void | HTTPValidationError;

/**
 * @summary Delete Funding Opportunity
 */
export const useDeleteFundingOpportunity = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFundingOpportunity>>,
      TError,
      { data: FundingOpportunityDeleteArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFundingOpportunity>>,
  TError,
  { data: FundingOpportunityDeleteArgs },
  TContext
> => {
  const mutationOptions = getDeleteFundingOpportunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing funding opportunity
 * @summary Update Funding Opportunity
 */
export const updateFundingOpportunity = (
  fundingOpportunityUpdateArgs: FundingOpportunityUpdateArgs,
  signal?: AbortSignal,
) => {
  return updateFundingOpportunityMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/funding-opportunities/update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: fundingOpportunityUpdateArgs,
    signal,
  });
};

export const getUpdateFundingOpportunityMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFundingOpportunity>>,
    TError,
    { data: FundingOpportunityUpdateArgs },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFundingOpportunity>>,
  TError,
  { data: FundingOpportunityUpdateArgs },
  TContext
> => {
  const mutationKey = ['updateFundingOpportunity'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFundingOpportunity>>,
    { data: FundingOpportunityUpdateArgs }
  > = (props) => {
    const { data } = props ?? {};

    return updateFundingOpportunity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFundingOpportunityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFundingOpportunity>>
>;
export type UpdateFundingOpportunityMutationBody = FundingOpportunityUpdateArgs;
export type UpdateFundingOpportunityMutationError = void | HTTPValidationError;

/**
 * @summary Update Funding Opportunity
 */
export const useUpdateFundingOpportunity = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFundingOpportunity>>,
      TError,
      { data: FundingOpportunityUpdateArgs },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFundingOpportunity>>,
  TError,
  { data: FundingOpportunityUpdateArgs },
  TContext
> => {
  const mutationOptions = getUpdateFundingOpportunityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves currently available funding opportunitys
 * @summary Get Funding Opportunities
 */
export const getFundingOpportunities = (
  params: GetFundingOpportunitiesParams,
  signal?: AbortSignal,
) => {
  return getFundingOpportunitiesMutator<FundingOpportunity[]>({
    url: `${import.meta.env['VITE_API_HOST']}/funding-opportunities/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetFundingOpportunitiesQueryKey = (params?: GetFundingOpportunitiesParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/funding-opportunities/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFundingOpportunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunities>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFundingOpportunitiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFundingOpportunities>>> = ({
    signal,
  }) => getFundingOpportunities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFundingOpportunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFundingOpportunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFundingOpportunities>>
>;
export type GetFundingOpportunitiesQueryError = void | HTTPValidationError;

export function useGetFundingOpportunities<
  TData = Awaited<ReturnType<typeof getFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundingOpportunities>>,
          TError,
          Awaited<ReturnType<typeof getFundingOpportunities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFundingOpportunities<
  TData = Awaited<ReturnType<typeof getFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFundingOpportunities>>,
          TError,
          Awaited<ReturnType<typeof getFundingOpportunities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFundingOpportunities<
  TData = Awaited<ReturnType<typeof getFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Funding Opportunities
 */

export function useGetFundingOpportunities<
  TData = Awaited<ReturnType<typeof getFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  params: GetFundingOpportunitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFundingOpportunities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFundingOpportunitiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves currently available funding opportunitys
 * @summary Count Funding Opportunities
 */
export const countFundingOpportunities = (signal?: AbortSignal) => {
  return countFundingOpportunitiesMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/funding-opportunities/count`,
    method: 'GET',
    signal,
  });
};

export const getCountFundingOpportunitiesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/funding-opportunities/count`] as const;
};

export const getCountFundingOpportunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof countFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunities>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountFundingOpportunitiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countFundingOpportunities>>> = ({
    signal,
  }) => countFundingOpportunities(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countFundingOpportunities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountFundingOpportunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof countFundingOpportunities>>
>;
export type CountFundingOpportunitiesQueryError = void | HTTPValidationError;

export function useCountFundingOpportunities<
  TData = Awaited<ReturnType<typeof countFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFundingOpportunities>>,
          TError,
          Awaited<ReturnType<typeof countFundingOpportunities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountFundingOpportunities<
  TData = Awaited<ReturnType<typeof countFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countFundingOpportunities>>,
          TError,
          Awaited<ReturnType<typeof countFundingOpportunities>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountFundingOpportunities<
  TData = Awaited<ReturnType<typeof countFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count Funding Opportunities
 */

export function useCountFundingOpportunities<
  TData = Awaited<ReturnType<typeof countFundingOpportunities>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countFundingOpportunities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountFundingOpportunitiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
